app.factory('fileUploadModel', ['$rootScope', 'baseModel', 'fileUploadService',
    function($rootScope, baseModel, fileUploadService) {

        function FileUploadModel() {

            this.uploadFile = function (file) {
                fileUploadService.uploadFile(file.data).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.FILE_UPLOAD.UPLOAD_FILE.SUCCESS, dataPage, file);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.FILE_UPLOAD.UPLOAD_FILE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                    }
                );
            };

            this.uploadExport = function (file) {
                return fileUploadService.uploadFile(file.data).then(
                    function (data) {
                        return data;

                    },
                    function (error) {
                        $rootScope.$broadcast(Event.FILE_UPLOAD.UPLOAD_FILE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                    }
                );
            };
        }

        return new FileUploadModel();
    }
]);
